import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet, TextInput, ScrollView } from 'react-native';
import { getCleanUrl, toBool } from '../../utils/Helper';
import { useCssStyle } from '../../customHook/getCssStyle';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { ImageComp } from '../../components/Image/Image';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigation } from '@react-navigation/native';
import CustomPressable from '../../components/customPressable/customPressable';
import { CHECK, SUCCESS_CHECK } from '../../assets';
import FetchingDataScreen from '../../components/fetchingDataScreen';
import { getServerDateTime } from '../../Redux/Actions/serverDateTimeAction';
import { checkPreCheckInWidgetState } from '../../js/preCheckInWidgetState';
import { current_client_config, EARLY_CHECKIN, MOBILE_CHECKIN, MOBILE_CHECKIN_CATEGORY, PRE_CHECKIN } from '../../config/Constant';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';
import { setGoHome } from '../../Redux/Reducers/appConfigReducer';
import { formatTime } from '../../js/formatTime';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useTranslation } from 'react-i18next';
import { CustomTextInput } from '../../components/customTextInput';
import { sendAnalytics } from '../../Redux/Actions/analyticsAction';

const PreCheckInSuccess = ({checkinSessionToken, hasJustCompletedPreCheckIn, handleProceedToCheckin }) => {


    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();

    const { currentWidget } = useSelector(state => state.deviceConfigSlice);
    const imgUrl = getCleanUrl(currentWidget?.widgetHeaderImageUrl);

    const { preCheckInWidgetState } = useSelector(state => state.checkInSlice);
    const { preCheckInData } = useSelector(state => state.checkInSlice.preCheckInStatus);

    const { serverTimeDataObj } = useSelector(state => state.serverDateTimeSlice);


    const { mobileCheckInConfigs } = useSelector(state => state.deviceConfigSlice.webAppWidgetsInfo) || {};
    const TIME_FORMAT = useSelector(state => state.deviceConfigSlice?.extraConfigParam?.TIME_FORMAT_MERIDIEM) || false;

    const checkinStartTime = formatTime(mobileCheckInConfigs.checkInStartTime, toBool(TIME_FORMAT))
    const earlyCheckInStartTime = formatTime(mobileCheckInConfigs.earlyCheckInStartTime, toBool(TIME_FORMAT))


    const [loading, setLoading] = useState(false);
    const [isPreCheckInDoneViaDevice, setIsPreCheckInDoneViaDevice] = useState(false);

    const [confirmationNumber, setConfirmationNumber] = useState('');


    const handleGoBack = () => {
        dispatch(setGoHome(true));
    }


    const handleCheckIn = () => {

        if (!isPreCheckInDoneViaDevice) {

            if (!confirmationNumber) {
                dispatch(setRenderFlashMessage(true, { type: "danger", message: "Please enter a valid booking number" }));
                return;
            }

            if (confirmationNumber != preCheckInData.confirmationNumber) {
                dispatch(setRenderFlashMessage(true, { type: "danger", message: t('pre_checkIn.error_matching_booking_number') }));
                return;
            }
        }

        handleProceedToCheckin();
    }


    const checkIfPreCheckInDoneViaSameDevice = async () => {
        const preCheckInDataAsPerHotel = await AsyncStorage.getItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST");

        const preCheckInData = preCheckInDataAsPerHotel && JSON.parse(preCheckInDataAsPerHotel)?.[current_client_config]

        if (preCheckInData) {
            setIsPreCheckInDoneViaDevice(true);
        } else {
            setIsPreCheckInDoneViaDevice(false);
        }
    }

    useEffect(() => {
        dispatch(checkPreCheckInWidgetState());
        setLoading(false);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serverTimeDataObj])

    useEffect(() => {
        setLoading(true);
        dispatch(getServerDateTime());
        checkIfPreCheckInDoneViaSameDevice()
        dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "PRE CHECK-IN - SUCCESS PAGE", { "element": "widget", "widgetSessionId": checkinSessionToken}));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const renderHeader = () => {


        return (
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'preCheckInHeaderContainer'])} id='widgetmainContainerHeaderContainer preCheckInHeaderContainer'>
                {!imgUrl ? <View style={getStyles(['preCheckInContainerHeaderImgContainer'])} id='preCheckInContainerHeaderImgContainer'>
                    <View style={getStyles(['preCheckInContainerHeaderImgBackground'])} id='preCheckInContainerHeaderImgBackground'>
                        <ImageComp source={SUCCESS_CHECK} style={getStyles(['preCheckInContainerHeaderImg'])} id="preCheckInContainerHeaderImg" />
                    </View>
                </View>
                : <ImageComp source={getCleanUrl(imgUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'preCheckInMainContainerHeaderImg'])} id="widgetmainContainerHeaderImg preCheckInMainContainerHeaderImg" />
                }


                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'preCheckInHeaderTitleContainer'])} id='widgetmainContainerHeaderTitleContainer preCheckInHeaderTitleContainer' >
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'preCheckInHeaderTitle'])} id='widgetmainContainerHeaderTitle preCheckInHeaderTitle' >{t('check_in.precheckin_success.heading')}</Text>
                    {t('check_in.precheckin_success.sub_heading') && <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'preCheckInHeaderSubTitle'])} id='widgetmainContainerHeaderSubTitle preCheckInHeaderSubTitle' >{t('check_in.precheckin_success.sub_heading')}</Text>}
                </View>
            </View>
        )
    }

    return (
        <View style={getStyles(['widgetRootContainer', 'preCheckInRootContainer'])} id='widgetRootContainer preCheckInRootContainer'>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />

            <ScrollView automaticallyAdjustKeyboardInsets={true} contentContainerStyle={getStyles(['widgetmainContainer', 'preCheckInMainContainer'])} showsVerticalScrollIndicator={false} id='widgetmainContainer preCheckInMainContainer'>
                {renderHeader()}


                <View style={getStyles(['widgetmainContainerChildContainer', 'preCheckInMainContainerChildContainer'])} id='widgetmainContainerChildContainer preCheckInMainContainerChildContainer'>


                    {
                        preCheckInData.checkinDate <= serverTimeDataObj?.date?.split("T")[0] ?

                            preCheckInWidgetState == PRE_CHECKIN || preCheckInWidgetState == EARLY_CHECKIN ?
                                <Text style={getStyles(['preCheckInMainContainerChildContainer_infoText'])} id='preCheckInMainContainerChildContainer_infoText'>
                                    {hasJustCompletedPreCheckIn ? t('check_in.preCheckIn_success_now_cannotCheckIn_checkInDay').replace("#checkInStartTime", checkinStartTime).replace("#earlyCheckInStartTime", earlyCheckInStartTime) 
                                        : t('check_in.preCheckIn_success_before_cannotCheckIn_CheckInDay').replace("#GUESTNAME", preCheckInData.guestName || "").replace("#checkInStartTime", checkinStartTime).replace("#earlyCheckInStartTime", earlyCheckInStartTime)}
                                </Text>
                                :
                                <Text style={getStyles(['preCheckInMainContainerChildContainer_infoText'])} id='preCheckInMainContainerChildContainer_infoText'>
                                    {hasJustCompletedPreCheckIn 
                                        ? t('check_in.preCheckIn_success_now_canCheckIn').replace("#checkInStartTime", checkinStartTime).replace("#earlyCheckInStartTime", earlyCheckInStartTime) 
                                        : t('check_in.preCheckIn_success_before_canCheckIn').replace("#GUESTNAME", preCheckInData.guestName || "").replace("#checkInStartTime", checkinStartTime).replace("#earlyCheckInStartTime", earlyCheckInStartTime)}
                                </Text>
                            :
                            <Text style={getStyles(['preCheckInMainContainerChildContainer_infoText'])} id='preCheckInMainContainerChildContainer_infoText'>
                                {hasJustCompletedPreCheckIn 
                                ? t('check_in.preCheckIn_success_now_cannotCheckIn').replace("#checkInStartTime", checkinStartTime).replace("#earlyCheckInStartTime", earlyCheckInStartTime) 
                                : t('check_in.preCheckIn_success_before_cannotCheckIn').replace("#GUESTNAME", preCheckInData.guestName || "").replace("#checkInStartTime", checkinStartTime).replace("#earlyCheckInStartTime", earlyCheckInStartTime)}
                            </Text>
                    }



                    <View style={getStyles([ 'preCheckInMainContainerChildContainer_buttonContainer'])} id='preCheckInMainContainerChildContainer_buttonContainer'>
                        {preCheckInData.checkinDate <= serverTimeDataObj?.date?.split("T")[0] && (
                            <>
                                {!isPreCheckInDoneViaDevice && preCheckInWidgetState != PRE_CHECKIN && (
                                    <View style={getStyles(['textContainer'])} id='textContainer'>
                                        <Text style={getStyles(['label'])} id='label'>
                                            {t('check_in.precheckin_success.confirmation_no')} 
                                            <Text style={getStyles(['requiredText'])}>*</Text>
                                        </Text>
                                        <CustomTextInput
                                            value={confirmationNumber}
                                            onChangeText={setConfirmationNumber}
                                            placeholder={t('check_in.precheckin_success.confirmation_no_placeholder')}
                                        />
                                    </View>
                                )}

                                <CustomPressable style={getStyles(['primaryBtn'])} id="primaryBtn" disabled={preCheckInWidgetState == PRE_CHECKIN} onPress={handleCheckIn}>
                                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt' >{t('check_in.precheckin_success.primary_button')}</Text>
                                </CustomPressable>
                            </>
                        )}
                        <CustomPressable style={getStyles(['secondaryBtn'])} id="secondaryBtn" onPress={handleGoBack}>
                            <Text style={getStyles(['secondaryBtnTxt'])} id='secondaryBtnTxt '>{t('check_in.precheckin_success.secondary_button')}</Text>
                        </CustomPressable>

                    </View>

                </View>
            </ScrollView>

            {loading && <FetchingDataScreen />}
        </View>
    );
};

export default PreCheckInSuccess;
